import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddDegree } from "./addModal";
import { loadDegrees } from "./loadData";
import { DegreeHeaders } from "./tableHeaders";

const Degrees = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [degrees, setDegrees] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});

  useEffect(() => {
    loadDegrees(setLoading).then(setDegrees);
    
  }, [location.pathname, update]);

  return (
    <AdminPage title="Degrees">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Degree Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData.degreeName}
            description={viewModalData.degreeNote}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <AddDegree opened={opened} setOpened={setOpened} setUpdate={setUpdate} />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={DegreeHeaders}
          rowData={degrees}
          showAddButton={true}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          opened={opened}
          setOpened={setOpened}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Degrees);
